// extracted by mini-css-extract-plugin
export default {"gridView":"main_gridView__h5LU6","container":"main_container__S6kiu","gridContainer":"main_gridContainer__q8YCs","subContainer":"main_subContainer__QVqcF"};